"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var types = exports.types = {
    MARKER_LAYOUT: 1
};


//////////////////
// WEBPACK FOOTER
// ./~/yandex-map-react/lib/constants/index.js
// module id = 1146
// module chunks = 0